import {
  INBOX_FILTERS_KEY,
  INBOX_LAST_CONVERSATION_KEY,
} from '@wit-support/admin-module-conversations/client';
import { CHARGEBACKS_FILTERS_KEY } from '@wit-support/admin-module-chargebacks/client';

/**
 * Ключи `localStorage`, в которых модули держат СОСТОЯНИЕ ЭКРАНА конкретного
 * оператора: открытый диалог, фильтры инбокса (включая поисковый запрос) и
 * фильтры списка кейсов (включая поиск по номеру кейса и последним 4 цифрам
 * карты).
 *
 * Список собран в одном месте намеренно: каждый модуль, который начинает
 * что-то запоминать между переходами, обязан попасть сюда — иначе следующий
 * оператор за той же машиной откроет раздел с чужим поиском. Забыть про это
 * легко ровно потому, что забытый ключ ничего не ломает и никак не виден.
 */
export const PERSISTED_SCREEN_STATE_KEYS: readonly string[] = [
  INBOX_FILTERS_KEY,
  INBOX_LAST_CONVERSATION_KEY,
  CHARGEBACKS_FILTERS_KEY,
];

/**
 * Стирает состояние экранов при выходе оператора. Лучшее усилие: отказ
 * хранилища (приватный режим, отключённые данные сайта) не должен задержать
 * редирект на страницу входа.
 */
export function clearPersistedScreenState(): void {
  try {
    for (const key of PERSISTED_SCREEN_STATE_KEYS) window.localStorage.removeItem(key);
  } catch {
    /* хранилище недоступно — выход всё равно обязан состояться */
  }
}
